// extracted by mini-css-extract-plugin
module.exports = {"base":"CookieSettings-module-base"};